import React from 'react';
import NavBar from '../../../components/layout/navbar';
import FormCertificado from '../../../components/configuracao/form-certificado';

export default function Certificado(){
    return(
        <>
            <NavBar />
            <FormCertificado />
        </>
    )
}